import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpExpressionDefinitionFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

// @ts-ignore noUnusedLocals
import { ExpExpressionNodeFactory } from "./ExpExpressionNode";
// @ts-ignore noUnusedLocals
import { ExpAdditionalDataFactory } from "./ExpAdditionalData";
// @ts-ignore noUnusedLocals
import { ExpAdditionalIDPropertiesFactory } from "./ExpAdditionalIDProperties";
// @ts-ignore noUnusedLocals
import { ExpExpressionDefinitionOutputFactory } from "./ExpExpressionDefinitionOutput";
// @ts-ignore noUnusedLocals
import { ExpTemplateConfigurationFactory } from "./ExpTemplateConfiguration";

/**
 * 
 * @export
 * @interface ExpExpressionDefinition
 */

export class ExpExpressionDefinitionFactory {}
_ExpExpressionDefinitionFactory = ExpExpressionDefinitionFactory;
_defineProperty(ExpExpressionDefinitionFactory, "FromJSON", function (json) {
  return _ExpExpressionDefinitionFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpExpressionDefinitionFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'id': json['id'],
    'additionalIdProperties': json['additionalIdProperties'] === null || json['additionalIdProperties'] === undefined ? json['additionalIdProperties'] : ExpAdditionalIDPropertiesFactory.FromJSON(json['additionalIdProperties']),
    'label': json['label'],
    'description': json['description'],
    'domainID': json['domainID'],
    'version': json['version'],
    'editable': json['editable'],
    'additionalData': json['additionalData'] === null || json['additionalData'] === undefined ? json['additionalData'] : ExpAdditionalDataFactory.FromJSON(json['additionalData']),
    'rootNode': ExpExpressionNodeFactory.FromJSON(json['rootNode']),
    'isComplete': json['isComplete'],
    'templateConfiguration': json['templateConfiguration'] === null || json['templateConfiguration'] === undefined ? json['templateConfiguration'] : ExpTemplateConfigurationFactory.FromJSON(json['templateConfiguration']),
    'output': json['output'] === null || json['output'] === undefined ? json['output'] : ExpExpressionDefinitionOutputFactory.FromJSON(json['output']),
    'executionFlags': json['executionFlags'] === null || json['executionFlags'] === undefined ? json['executionFlags'] : json['executionFlags']
  };
});
_defineProperty(ExpExpressionDefinitionFactory, "ToJSON", function (value) {
  return _ExpExpressionDefinitionFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpExpressionDefinitionFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'id': value.id,
    'additionalIdProperties': ExpAdditionalIDPropertiesFactory.ToJSON(value.additionalIdProperties),
    'label': value.label,
    'description': value.description,
    'domainID': value.domainID,
    'version': value.version,
    'editable': value.editable,
    'additionalData': ExpAdditionalDataFactory.ToJSON(value.additionalData),
    'rootNode': ExpExpressionNodeFactory.ToJSON(value.rootNode),
    'isComplete': value.isComplete,
    'templateConfiguration': ExpTemplateConfigurationFactory.ToJSON(value.templateConfiguration),
    'output': ExpExpressionDefinitionOutputFactory.ToJSON(value.output),
    'executionFlags': value.executionFlags
  };
});
//# sourceMappingURL=ExpExpressionDefinition.js.map
